import { createApp } from 'vue';
import App from './App.vue';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'; // 导入已经创建好的router实例
import {
    Button,
    Tabbar,
    TabbarItem,
    Tab,
    Tabs,
    Popup,
    Image as VanImage,
    Search,
    Cell,
    CellGroup,
    Icon,
    Swipe,
    SwipeItem,
    Grid,
    GridItem,
    NavBar,
    IndexBar,
    IndexAnchor,
    Form,
    Field,
    Picker,
    Area,
    Checkbox,
    DropdownMenu,
    DropdownItem,
    Collapse,
    CollapseItem,
    List,
    PullRefresh
} from 'vant';
// 2. 引入组件样式
import 'vant/lib/index.css';

const app = createApp(App);
app.use(ElementPlus)
app.use(router);
app.use(Button);
app.use(Tabbar);
app.use(TabbarItem);
app.use(Tab);
app.use(Tabs);
app.use(Popup);
app.use(VanImage);
app.use(Search);
app.use(Cell);
app.use(CellGroup);
app.use(Icon);
app.use(Swipe);
app.use(SwipeItem);
app.use(Grid);
app.use(GridItem);
app.use(NavBar);
app.use(IndexBar);
app.use(IndexAnchor);
app.use(Form);
app.use(Field);
app.use(Picker);
app.use(Area);
app.use(Checkbox);
app.use(DropdownMenu);
app.use(DropdownItem);
app.use(Collapse);
app.use(CollapseItem);
app.use(List);
app.use(PullRefresh);
app.mount('#app');
